import React, { useEffect, useRef, useCallback } from "react";

const SITE_KEY = "0x4AAAAAAC__ReUYeC1G7KAn";

interface TurnstileWidgetProps {
  onVerify: (token: string) => void;
  onExpire?: () => void;
}

export default function TurnstileWidget({ onVerify, onExpire }: TurnstileWidgetProps) {
  const containerRef = useRef<HTMLDivElement>(null);
  const widgetIdRef = useRef<string | null>(null);

  const renderWidget = useCallback(() => {
    if (!containerRef.current || widgetIdRef.current !== null) return;
    if (typeof window.turnstile === "undefined") return;

    widgetIdRef.current = window.turnstile.render(containerRef.current, {
      sitekey: SITE_KEY,
      callback: onVerify,
      "expired-callback": onExpire,
      theme: "light",
      size: "normal",
    });
  }, [onVerify, onExpire]);

  useEffect(() => {
    // Turnstile script may load after component mounts
    if (typeof window.turnstile !== "undefined") {
      renderWidget();
    } else {
      const interval = setInterval(() => {
        if (typeof window.turnstile !== "undefined") {
          clearInterval(interval);
          renderWidget();
        }
      }, 200);
      return () => clearInterval(interval);
    }

    return () => {
      if (widgetIdRef.current !== null && typeof window.turnstile !== "undefined") {
        try { window.turnstile.remove(widgetIdRef.current); } catch {}
        widgetIdRef.current = null;
      }
    };
  }, [renderWidget]);

  return <div ref={containerRef} />;
}
